import { reactive, ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { saveCommonConfig } from '@/api/payManage/appManage';
import { OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CommonModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null
  },
  emits: ['update:modalVisible', 'update:editItem', 'refreshList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const orderForm = reactive({
      notifyUrl: ''
    });
    const orderRef = ref(null);
    const closeModal = () => {
      var _orderRef$value;
      Object.assign(orderForm, initForm());
      (_orderRef$value = orderRef.value) === null || _orderRef$value === void 0 || _orderRef$value.clearValidate();
      emit('update:modalVisible', false);
      emit('update:editItem', {});
    };
    const initForm = () => {
      return {
        notifyUrl: ''
      };
    };
    const submitModal = () => {
      var _orderRef$value2;
      (_orderRef$value2 = orderRef.value) === null || _orderRef$value2 === void 0 || _orderRef$value2.validate().then(async () => {
        let params = {
          commonConfigData: {
            notifyUrl: orderForm.notifyUrl
          },
          dbtId: orderForm.dbtId
        };
        try {
          const {
            code,
            msg
          } = await saveCommonConfig(params);
          if (code === OK) {
            message.success(msg);
            closeModal();
            emit('refreshList');
            reportEvent({
              eventName: 'element_use',
              properties: {
                'ui_name': '产品管理',
                'element_name': '通用配置'
              }
            });
          }
        } catch (error) {}
      }).catch(err => {});
    };
    watch(() => props.editItem, n => {
      if (typeof n === 'object') {
        Object.assign(orderForm, n);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "通用配置详情",
        onCancel: closeModal,
        onOk: submitModal,
        centered: "",
        open: __props.modalVisible,
        width: "523px",
        "ok-text": "提交"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "order",
          model: orderForm,
          ref_key: "orderRef",
          ref: orderRef,
          "label-col": {
            span: 6
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "S2S回调地址：",
            name: "notifyUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.notifyUrl,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => orderForm.notifyUrl = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "强联网游戏填写"
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});